import React from 'react'

import { gql } from '@apollo/client'
import { segmentsClient } from '../../../../utils/apollo/api'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useSegmentationState = () => React.useContext(Context)
export const useSegmentation = () => useSegmentationState()?.segment

const QUERY = gql`
  query Segment($id: ID) {
    segment(id: $id) {
      id
      name
      placeLevels {
        id
        name
      }
      checklistTypes {
        id
        name
      }
      userGroups {
        id
        name
      }
      assets {
        id
        name
      }
    }
  }
`

const SegmentationLoader = ({ children, id }) => {
  const { data, ...state } = useQuery(QUERY, {
    skip: !id,
    variables: { id },
    client: segmentsClient,
    fetchPolicy: 'no-cache'
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default SegmentationLoader
